import { ethers } from "ethers";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  /*

  0 - Connect
  1 - Get Balance and Approve to Migrate
  2 - Migrate
  100 - Message
  1000 - Metamask not installed
  */

  const [status, setStatus] = useState(0);

  const [showLoader, setShowLoader] = useState(false);

  const [prv, setProvider] = useState("");
  const [acc, setAccount] = useState("");

  /*
  Configuration
  */

  const config_chainId = "0x89"; //Mumbai Testnet
  const config_msg_chainId =
    "Current chain is wrong.\nSet it to Polygon Chain.";
  const config_msg_metamask = "Metamask is not installed!";
  const config_msg_network = "Connection lost, retry again!";
  const config_msg_metamask_error = "Metamask access denied!";
  //PolWhirl Contract
  const config_contract_abi = JSON.parse(
    '[{"inputs":[{"internalType":"uint256","name":"totalSupply","type":"uint256"},{"internalType":"uint256","name":"initialSupply","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]'
  );
  const config_contract = "0xfC5a11D0fe8B5AD23b8A643Df5EAE60b979CE1bF";
  //OmniWhirl Contract
  const config_newContract_abi = JSON.parse(
    '[{"inputs":[{"internalType":"uint256","name":"totalSupply","type":"uint256"},{"internalType":"address","name":"_tokenAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"migrate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenToMigrate","outputs":[{"internalType":"contract IERC20MintBurn","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]'
  );
  const config_newContract = "0x4F6cbacA3151f7746273004Fd7295933a9b70E69";

  //Using rendering effects to assign listeners!
  useEffect(() => {
    const checkConnection = async () => {
      if (!window.ethereum?.request) {
        toast.error(config_msg_metamask);
        setStatus(1000);
      } else {
        var provider = new ethers.providers.Web3Provider(
          window.ethereum,
          "any"
        );
        setProvider(provider);
        provider.on("network", (newNetwork, oldNetwork) => {
          if (oldNetwork) {
            if (newNetwork.chainId !== parseInt(config_chainId)) {
              toast.error(config_msg_chainId);
              setStatus(0);
            }
          }
        });
      }
    };

    checkConnection();
  }, []);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum?.on("accountsChanged", (accounts) => {
        if (accounts.length === 0) {
          setStatus(0);
        } else if (acc && acc.length > 0 && accounts[0] !== acc) {
          toast.error(
            "You have changed the wallet address! Reconnect to continue."
          );
          setStatus(0);
        }
      });
    }
  }, [acc]); //<-- We are passing the current account here!

  function handleError(err) {
    if (err.code === 4001) {
      toast.error(config_msg_metamask_error);
    } else {
      toast.error(config_msg_network);
    }
    
    setShowLoader(false);
  }

  async function connectInit() {
    setShowLoader(true);

    if (!window.ethereum?.request) {
      toast.error(config_msg_metamask, { autoClose: 25000 });
      return;
    }

    let provider = new ethers.providers.Web3Provider(window.ethereum);
    let accounts = await window.ethereum
      .request({
        method: "eth_requestAccounts",
      })
      .catch((err) => {
        handleError(err);
      });
    let chainId = await window.ethereum.request({
      method: "eth_chainId",
    });

    if (chainId !== config_chainId) {
      toast.error(config_msg_chainId);
      return;
    }

    if (accounts && accounts.length > 0) {
      setProvider(provider);
      setAccount(accounts[0]);
      setStatus(1);
    }

    setShowLoader(false);
  }

  async function approve() {
    setShowLoader(true);

    const signer = prv.getSigner();
    const contract = new ethers.Contract(
      config_contract,
      config_contract_abi,
      prv
    );
    const contractSigner = await contract.connect(signer);

    //getBalance first, then check aproved to spend
    const getBalance = await contractSigner.functions["balanceOf"](acc);

    const getApproved = await contractSigner.functions["allowance"](
      acc,
      config_newContract
    );

    if (getBalance <= 0) {
      toast.error(
        "You don't have any PolyWhirl ($WHIRL) tokens in your wallet!"
      );
    } else if (getApproved >= getBalance) {
      toast.info("You have already approved for migration!");
      setStatus(2);
    } else {
      //request for approval
      toast.info("Confirm the transaction to proceed!");

      let do_approve = await contractSigner.functions["approve"](
        config_newContract,
        String(getBalance)
      ).catch((err) => {
        handleError(err);
      });

      if (do_approve) {
        toast.info("Transaction submitted. Waiting to confirm...");
        await do_approve.wait();
        toast.success("Transaction was confirmed!");
        setStatus(2);
      }
    }

    setShowLoader(false);
  }

  async function migrate() {
    setShowLoader(true);

    const signer = prv.getSigner();
    const contract = new ethers.Contract(
      config_newContract,
      config_newContract_abi,
      prv
    );
    const contractSigner = await contract.connect(signer);

    toast.info("Confirm the transaction to start migration!");

    let do_approve = await contractSigner.functions["migrate"]().catch(
      (err) => {
        handleError(err);
      }
    );

    if (do_approve) {
      toast.info("Transaction submitted. Waiting to confirm...");
      await do_approve.wait();
      toast.success(
        "Transaction was confirmed! You have successfully migrated the tokens."
      );
      setStatus(100);
    }

    setShowLoader(false);
  }

  return (
    <div className="App">
      {showLoader ? (
        <div className="overlay-loader">
          <div className="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : null}

      {!showLoader && status === 0 ? (
        <div>
          <p>
            Before connecting make sure you are on Polygon Chain and you have
            PolyWhirl($WHIRL) in your wallet. If you aren't{" "}
            <a
              href="https://omniwhirl.medium.com/omniwhirl-migration-guide-7c4948c8573f"
              target="_blank"
              rel="noreferrer"
            >
              Read our guide
            </a>
            .
          </p>

          <div className="button_app">
            <button
              className="btn btn_with_ico p scale ripple mr-2"
              onClick={connectInit}
            >
              Connect with Metamask
            </button>
          </div>
        </div>
      ) : null}

      {!showLoader && status === 1 ? (
        <div>
          <p>Approve to Migrate from PolyWhirl to OmniWhirl</p>
          <div className="button_app">
            <button
              className="btn btn_with_ico p scale ripple mr-2"
              onClick={approve}
            >
              Approve to Migrate
            </button>
          </div>
        </div>
      ) : null}

      {!showLoader && status === 2 ? (
        <div>
          <p>Migrate PolyWhirl to OmniWhirl</p>
          <div className="button_app">
            <button
              className="btn btn_with_ico p scale ripple mr-2"
              onClick={migrate}
            >
              Migrate the Tokens
            </button>
          </div>
        </div>
      ) : null}

      {!showLoader && status === 100 ? (
        <div>
          <p>
            All done! You have successfully migrated your PolyWhirl Tokens to
            new OmniWhirl Tokens.
          </p>
        </div>
      ) : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
